export default __webpack_public_path__ + "static/media/groupBuyingShippingFeeEnglish.d54826ca.png";